<template>
  <v-app id="inspire">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="#3F3FFF">
                <v-toolbar-title>Instagram Pages</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-list>
                  <v-radio-group :mandatory="true" v-model="selected" name="list-ig">
                    <template v-for="item in facebookData">
                      <v-list-tile :key="item.id" avatar>
                        <v-list-tile-action>
                          <v-radio :value="item.id"></v-radio>
                        </v-list-tile-action>

                        <v-list-tile-content>
                          <v-list-tile-title v-text="item.name"></v-list-tile-title>
                          <v-list-tile-sub-title>
                            <a href>@{{item.username}}</a>
                          </v-list-tile-sub-title>
                          <v-list-tile-sub-title>{{item.followers_count}} followers</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-avatar>
                          <img :src="item.profile_picture_url" />
                        </v-list-tile-avatar>
                      </v-list-tile>
                    </template>
                  </v-radio-group>
                </v-list>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :disabled="!selected" color="secondary" @click="next">Next</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import api from '@/api';
import apiUrl from '../config/APIs';
export default {
  name: 'SelectInstagram',
  data() {
    return {
      facebookData: null,
      facebookId: null,
      selected: null
    };
  },
  methods: {
    selectInstagram(item) {
      this.selected = item.id;
    },
    next() {
      let body = {
        facebookId: this.facebookId,
        instagram: this.selected
      };
      api
        .request('POST', apiUrl.INSTAGRAM_GRAPH_API_HANDLE_SELECTION, false, body)
        .then(response => {
          let responseData = response.data;
          var userData = responseData ? responseData.userData : {};
          var jwtToken = responseData.jwtToken;

          // Remove jwt token from user data
          delete userData.jwtToken;

          /* Setting user in the state and caching record to the localStorage */
          var token = 'Bearer ' + jwtToken;

          this.$store.commit('SET_USER', userData);
          this.$store.commit('SET_TOKEN', token);
          // To-Do -> Fetch notifications data from server and assign here
          if (window.localStorage) {
            window.localStorage.setItem('user', JSON.stringify(userData));
            window.localStorage.setItem('token', token);
          }

          this.$router.push(this.$route.query.redirect ? this.$route.query.redirect : { name: 'Profile' });
        })
        .catch(() => {
          this.$swal({
            title: 'Error',
            text: 'Could not connect to this instagram account. Please select another. If you still face this issue, do not hesitate contact us at ',
            type: 'error'
          });
        });
    }
  },
  created() {
    let data = this.$store.state.facebook ? JSON.parse(this.$store.state.facebook) : {};
    this.facebookData = data.pages || [];
    this.selected = this.facebookData.length > 0 ? this.facebookData[0].id : null;
    this.facebookId = data.facebookId;
  }
};
</script>
<style>
#list-ig {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// SelectInstagram.vue?04c1f6e8